import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { record_type, int32_type, option_type, string_type, list_type, equals } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { AttributeDTO$reflection } from "./Model.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { Locale$reflection } from "../../Utils.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import * as react from "react";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { useSelector } from "../../Redux/Store.js";
import { getTranslationFrom } from "../../Global.js";
import { item, map, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { EditableTableProps, TableCell, EditType, renderEditableTable as renderEditableTable_1 } from "../../Components/Table/Table.js";
import "../../../src/Containers/ContractAttributes/View.scss";


export function API_loadAttributes(clientNr, contractNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Data/Contract/Attributes/%i/%i"))(clientNr)(contractNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(AttributeDTO$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(AttributeDTO$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(AttributeDTO$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function API_setAttribute(clientNr, contractNr, name, value) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Data/Contract/Attributes/%i/%i/%s"))(clientNr)(contractNr)(name)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_3, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(string_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(value));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(2), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(string_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

export class AttributesProps extends Record {
    constructor(ClientNr, ContractNr, Locale) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.ContractNr = (ContractNr | 0);
        this.Locale = Locale;
    }
}

export function AttributesProps$reflection() {
    return record_type("Containers.ContractAttributes.View.AttributesProps", [], AttributesProps, () => [["ClientNr", int32_type], ["ContractNr", int32_type], ["Locale", Locale$reflection()]]);
}

export class EditorState extends Record {
    constructor(Attributes) {
        super();
        this.Attributes = Attributes;
    }
}

export function EditorState$reflection() {
    return record_type("Containers.ContractAttributes.View.EditorState", [], EditorState, () => [["Attributes", option_type(list_type(AttributeDTO$reflection()))]]);
}

export const renderAttributes = FunctionComponent_Of_Z5A158BBF((props) => {
    const state = react.useState(new EditorState(void 0));
    const loadData = () => singleton.Delay(() => {
        state[1]((x) => (new EditorState(void 0)));
        return singleton.Bind(API_loadAttributes(props.ClientNr, props.ContractNr), (_arg) => {
            const data = _arg;
            if (data.tag === 0) {
                state[1]((_arg_1) => (new EditorState(data.fields[0])));
                return singleton.Zero();
            }
            else {
                return singleton.Zero();
            }
        });
    });
    react.useEffect(() => {
        startImmediate(loadData());
    }, [props.ClientNr, props.ContractNr]);
    const translationsLoadState = useSelector((state_1) => state_1.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    let attributesHtml;
    const matchValue = (state[0]).Attributes;
    if (matchValue != null) {
        const attributes = matchValue;
        const headers = ofArray([getTranslation("Common.Attribute"), getTranslation("Value")]);
        const renderEditableTable = renderEditableTable_1(new EditableTableProps(map((a) => ofArray([new TableCell(a.Name, new EditType(4), (v) => v, (str) => str), new TableCell(a.Value, new EditType(0), (v_1) => v_1, (str_1) => str_1)]), attributes), (cells) => {
            const value = item(1, cells).Value;
            const name = item(0, cells).Value;
            startImmediate(singleton.Delay(() => singleton.Bind(API_setAttribute(props.ClientNr, props.ContractNr, name, value), (_arg_2) => ((_arg_2.tag === 1) ? singleton.Return() : singleton.ReturnFrom(loadData())))));
        }, headers, props.Locale));
        attributesHtml = react.createElement("div", {
            className: "attributes__table",
        }, renderEditableTable);
    }
    else {
        attributesHtml = react.createElement(react.Fragment, {});
    }
    return react.createElement("div", {
        className: "attributes",
    }, attributesHtml);
}, void 0, uncurry(2, void 0), void 0, "renderAttributes", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\ContractAttributes\\View.fs", 100);

